import { isValidFilterValue } from "./useFilterValues";

export const generateFiltersParams = filters => {
  let params = {};

  if (!filters) return {};

  Object.keys(filters).map(key => {
    const filter = filters[key];

    if (filter) {
      if (Array.isArray(filter) && filter.length > 0) {
        const value = filter.map(el => el.value).filter(isValidFilterValue);

        if (value.length > 0) {
          params[key] = value;
        }
      } else if (Object.keys(filter).length !== 0 && filter.constructor === Object) {
        if (isValidFilterValue(filter.value)) {
          params[key] = filter.value;
        }
      } else if ((typeof filter === "string" && filter !== "") || [true, false].includes(filter)) {
        params[key] = filter;
      }
    } else {
      delete params[key];
    }
  });
  return params;
};
